import { LinkSection } from '../types/familyLinks';

const GOOGLE_SHEETS_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTqj8rLCS2l4s9sMchs0J7dA6U_-5bStIy8UhHVjo2uVei44CTMDSKFjZIZGKdnAH5b3RDBD2PvUvWa/pub?output=csv';

export const fetchLinksFromGoogleSheets = async (): Promise<LinkSection[]> => {
  try {
    const response = await fetch(GOOGLE_SHEETS_CSV_URL);

    if (!response.ok) {
      throw new Error('Failed to fetch data from Google Sheets');
    }

    const csvText = await response.text();
    return parseCSVToLinkSections(csvText);
  } catch (error) {
    console.error('Error fetching Google Sheets data:', error);
    throw error;
  }
};

const parseCSVToLinkSections = (csvText: string): LinkSection[] => {
  const lines = csvText.split('\n').filter(line => line.trim());
  const headers = lines[0].split(',').map(h => h.trim().replace(/"/g, ''));

  const nameIndex = headers.findIndex(h => h.toLowerCase().includes('name'));
  const urlIndex = headers.findIndex(h => h.toLowerCase().includes('url'));
  const categoryIndex = headers.findIndex(h => h.toLowerCase().includes('category'));

  if (nameIndex === -1 || urlIndex === -1 || categoryIndex === -1) {
    throw new Error('CSV must have columns: name, url, category');
  }

  const sectionsMap: { [key: string]: { id: string; name: string; url: string }[] } = {};

  for (let i = 1; i < lines.length; i++) {
    const columns = parseCSVLine(lines[i]);

    if (columns.length < 3) continue;

    const name = columns[nameIndex]?.trim();
    const url = columns[urlIndex]?.trim();
    const category = columns[categoryIndex]?.trim();

    if (!name || !url || !category) continue;

    if (!sectionsMap[category]) {
      sectionsMap[category] = [];
    }

    sectionsMap[category].push({ id: `sheet-${i}`, name, url });
  }

  return Object.entries(sectionsMap).map(([title, links]) => ({
    title,
    links
  }));
};

const parseCSVLine = (line: string): string[] => {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];

    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === ',' && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  result.push(current.trim());
  return result.map(field => field.replace(/^"|"$/g, ''));
};
